<template>
  <div>
    <el-dialog title="渠道发放" :visible="dialogPro" top="70px" :close-on-click-modal="false" width="450px" @close="cancel">
      <div>
        <div class="top_box">
          <div class="top_item acc">后台账号：{{ adminUser.user_login }}</div>
          <div class="top_item recored" @click="recored">发放记录</div>
          <div class="top_item out" @click="logout">退出登录</div>
        </div>
        <div class="item">
          <div class="label">渠道等级</div>
          <div class="content">
            <el-radio-group v-model="promoteLevel">
              <el-radio :label="1">一级</el-radio>
              <el-radio :label="2">二级</el-radio>
              <el-radio :label="3">三级</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="item">
          <div class="label">渠道账号</div>
          <div :class="['content',account ? 'checked' : '']" @click="dialogPromote=true">
            <div>{{ account ? account : '点击选择渠道' }}</div>
            <div v-if="is_first<3" :class="['first_box',is_first == 1?'two_box':'']">
              {{ is_first == 1 ? '首充' : '续充'}}
            </div>
          </div>
        </div>
        <div class="item">
          <div class="label">发放数量</div>
          <div>
            <el-input v-model="sendNum" :readonly="isReadonly" placeholder="输入发放数量"></el-input>
          </div>
        </div>
        <div class="desc_box">
          <div class="label">备注说明</div>
          <div style="margin-top: 10px;">
            <el-input v-model="desc" type="textarea" :rows="3" placeholder="备注说明"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div>数量：<span class="num">{{ sendNum || 0 }}</span></div>
        <el-button type="primary" :disabled='!isClick' @click="confirm">确认发放</el-button>
      </span>
    </el-dialog>
    <!-- 后台渠道列表 -->
    <pro-back :sendPro="true" :level="promoteLevel" @openLogin="openLogin" :dialogPromote.sync="dialogPromote"
      @checkPromote="checkPromote"></pro-back>

    <!-- 内团登录 -->
    <login :dialogInner.sync="dialogInner" @success="loginSuccess"></login>
    <el-dialog title="发放信息" :visible.sync="showPop" width="350px" :before-close="handleClose">
      <div class="upop_box">
        <div class="info_box">
          <ywater-mark></ywater-mark>
          <div class="bot_upop_box">
            <div class="account">渠道账号: {{account}}</div>
            <div class="bh">平台币数量: {{sendNum}}</div>
          </div>
        </div>
        <div>
          <div class="password_box">
            <div class="tip">请输入二级密码</div>
            <div class="put">
              <el-input v-model="password" type="password" placeholder="请输入二级密码"></el-input>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialoginfo-footer">

        <el-button type="primary" :loading="isPay" @click="confirmSend">确定发放</el-button>
      </span>
    </el-dialog>
    <!-- 发放成功 -->
    <el-dialog title="提示" :visible.sync="showSuccess" width="300px" :close-on-click-modal="false" @close="closeSuccess">
      <div class="success_box">
        <el-result icon="success" title="发放成功" subTitle="您的订单已发放成功">
        </el-result>
        <div class="copy_box">
          <ywater-mark></ywater-mark>

          <div class="info">
            <div class="account">账号: {{account}}</div>
            <div class="bh">平台币: {{ sendNum }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialoginfo-footer">
        <el-button type="primary" @click="copy">复制文本</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import proBack from '@/component/search_promote.vue'
  import login from '@/component/login.vue'
  import {
    adminDiscount,
    adminOrderNum,
    promotePtb
  } from "@/api/home";
  import ywaterMark from '@/component/ywaterMark.vue';
  export default {
    data() {
      return {
        account: '',
        sendNum: '',
        desc: '',
        adminUser: {},
        dialogInner: false,
        dialogPromote: false,
        promoteLevel: 1,
        is_control: 0,
        is_first: 3,
        isReadonly: true,
        promote_id: '',
        password: '',
        showPop: false,
        isPay: false,
        showSuccess: false
      }
    },
    components: {
      proBack: () => import("@/component/search_promote.vue"),
      login,
      ywaterMark
    },
    props: {
      dialogPro: {
        default: false
      },
      info: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    computed: {
      isClick() {
        return !this.isReadonly && this.sendNum > 0
      },
    },
    watch: {
      dialogPro(n, o) {
        if (n) {
          this.init()
          let info = this.info
          this.adminUser = JSON.parse(localStorage.getItem('adminUser'))
          // console.log(this.adminUser.user_login)
          if (info) {
            this.account = info.account
            this.is_control = info.is_control

          }
        }
      }
    },
    methods: {
      init() {
        this.account = ''
        this.promote_id = ''
        this.isReadonly = true
        this.is_first = 3
        this.is_control = 0
        this.sendNum = ''
        this.desc = ''
        this.promoteLevel = 1
        this.password = ''
        this.showPop = false
        this.isPay = false
        this.showSuccess = false
      },
      handleClose(done) {
        this.$confirm('是否确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      cancel() {
        this.$emit('update:dialogPro', false)
      },
      confirm() {
        let backPay = localStorage.getItem('backPay')
        if (backPay) {
          this.password = backPay
        }
        this.showPop = true
      },
      recored() {
        this.$router.push({
          name: 'promoteRecored'
        })
      },
      openLogin() {
        this.$emit('update:dialogPro', false)
        this.dialogInner = true
      },
      //选择渠道
      checkPromote(v) {
        this.dialogPromote = false
        this.isReadonly = false
        this.account = v.account
        this.promote_id = v.id
      },
      openLogin() {
        this.$emit('update:dialogPro', false)
        this.dialogInner = true
      },
      loginSuccess() {
        this.$emit('update:dialogPro', true)
        setTimeout(() => {
          this.$message({
            message: '登录成功',
            type: "success"
          });
        }, 200)
      },
      logout() {
        this.$confirm('确认退出?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          localStorage.removeItem('adminUser')
          this.$emit('update:dialogPro', false)
          this.$message({
            type: 'success',
            message: '退出成功!'
          });

        }).catch(() => {

        });
      },
      //确认发放
      confirmSend() {
        if (!this.password) {
          this.$message({
            message: '请输入交易密码',
            type: 'warning'
          });
          return
        }
        this.isPay = true
        let params = {
          promote_id: this.promote_id,
          num: this.sendNum,
          second_pwd: this.password,
          remark: this.desc,
          admin_token: this.adminUser.admin_token
        }
        promotePtb(params).then(res => {
          if (res.code === 200) {
            this.showPop = false
            this.showSuccess = true
            this.time = this.$tools.timeFormatter(new Date().getTime())
            localStorage.setItem('backPay', this.password)

          } else {
            // this.showErr = true
            // this.errMsg = res.msg
          }
          this.isPay = false
        })

      },
      copy() {
        let data = `
渠道账号：${this.account}
发放数量：${this.sendNum}
发放时间：${this.time}
亲！您的平台币加币已发放到账，祝您日进斗金~`
        this.$tools.copyText(data, this)
      },
      closeSuccess() {
        this.showPop = false
        this.$emit('update:dialogPro', false)
      }
    }
  }
</script>

<style scoped lang="less">
  /deep/ .el-input__inner {
    background-color: #F3F6F5;
    border: none;
  }

  .top_box {
    display: flex;
    justify-content: space-between;

    .top_item {
      color: white;
      font-size: 15px;
      border-radius: 3px;
      padding: 2px 6px;
      cursor: pointer;
    }

    .acc {
      background-color: #8bb8f5;
    }

    .recored {
      background-color: #29D894;
    }

    .out {
      background-color: #FF9797;
    }
  }

  .desc_box {
    margin-top: 15px;
    font-size: 15px;
    background-color: #F3F6F5;
    padding: 10px 20px 20px;
    box-sizing: border-box;
    border-radius: 5px;

    /deep/ .el-textarea__inner {
      background-color: #F3F6F5;
    }
  }

  .item {
    display: flex;
    margin-top: 15px;
    font-size: 15px;
    background-color: #F3F6F5;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
    height: 40px;
    border-radius: 5px;

    .put_box {
      flex: 1;
    }

    .content {
      color: #c0c4cc;
      margin-left: 15px;
      cursor: pointer;
      display: flex;
      align-items: center;

      .first_box {
        width: 45px;
        height: 20px;
        border: 1px solid #29D894;
        color: #29D894;
        font-size: 14px;
        border-radius: 5px;
        text-align: center;
        line-height: 20px;
        margin-left: 5px;
      }

      .two_box {
        border: 1px solid #FF8484;
        color: #FF8484;
      }

      .y_box {
        width: 45px;
        height: 20px;
        border: 1px solid #FF8484;
        color: #FF8484;
        font-size: 14px;
        border-radius: 5px;
        text-align: center;
        line-height: 20px;
        margin-left: 5px;
      }
    }

    .checked {
      color: #767676;
    }



    &:first-child {
      margin-top: 0;
    }

    .label {
      width: 62px;
      flex-shrink: 0;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: space-between;

    .num {
      font-size: 20px;
      font-weight: bold;
      color: red;
    }
  }


  .upop_box {
    position: relative;
    z-index: 99999999;

    .pay_time {
      margin-top: 10px;
      font-size: 15px;
      text-align: center;

      .time {
        color: #FF8484;
      }
    }

    .info_box {
      background-color: #fffbfb;
      border-radius: 15px;
      text-align: center;
      font-size: 14px;
      margin-top: 10px;
      padding: 8px 0;
      position: relative;
      z-index: 999;

      .game_box {
        // margin-top: 15rpx;
        position: relative;
        z-index: 99;
      }

      .bot_upop_box {
        margin-top: 8px;
        position: relative;
        z-index: 99;
        text-align: center;

        .account {
          color: #FF6C00;
        }

        .bh {
          color: #29D894;
          margin: 0 5px;
        }

        .zhe {
          color: red;
        }
      }
    }



    .password_box {
      .tip {
        text-align: center;
        margin-top: 25px;
        font-weight: bold;
        font-size: 15px;
      }

      .put {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;

        .eye {
          margin-left: 10px;
        }
      }

      .dialoginfo-footer {
        text-align: right;
      }
    }
  }

  .copy_box {
    // height: 120rpx;
    background-color: #fffbfb;
    margin-top: 15px;
    border-radius: 10px;
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    z-index: 10;

    .game {
      position: relative;
      z-index: 10;
    }

    .info {
      margin-top: 20rpx;
      position: relative;
      z-index: 10;
    }

    .account {
      color: #FF6C00;
      margin: 4px 0;
    }

    .bh {
      color: #29D894;

    }

    .zhe {
      color: red;
    }
  }
</style>


// WEBPACK FOOTER //
// src/component/home/promote_send.vue